import { getImageAttributes } from '@notino/react-web-utils';

import { useApplicationBuildContext } from '@context/ApplicationBuildContext';

export const useGetImageAttributes = (url: string, sourceKey: string = '', alt: string = '') => {
  const {
    settings: { cdnBaseUrlAddress },
  } = useApplicationBuildContext();

  return getImageAttributes({ src: url, alt }, cdnBaseUrlAddress, sourceKey);
};
